import { Component } from '@angular/core';

@Component({
  selector: 'app-bom-compare',
  templateUrl: './bom-compare.component.html',
  styleUrl: './bom-compare.component.css'
})
export class BomCompareComponent {

}
